import { getMyCreatorEarnings, getMyCreatorEarningsDetails } from '@sp/data/bif';
import { createResource } from '@sp/util/helpers';

export const CREATOR_EARNINGS_MODEL = {
  earnings: createResource(getMyCreatorEarnings),
  details: createResource(getMyCreatorEarningsDetails),
};
